import React, { useState, useEffect, useMemo } from "react";
import axiosClient from "../../../api-client/AxiosClient.js";
import ReusableTable from "../ReusableTable.js";

const AuditLogsTable = () => {
  const [tableData, setTableData] = useState([]);
  const logs =  [
    { timestamp: "2024-02-27 14:20:00", user: "admin", action: "LOGIN", details: "View in from IP 192.168.1.1" },
    { timestamp: "2024-02-27 14:30:00", user: "john_doe", action: "UPDATE", details: "Updated record ID 123" },
    { timestamp: "2024-02-27 14:35:00", user: "admin", action: "DELETE", details: "Deleted user ID 45" },
    { timestamp: "2024-02-27 15:00:00", user: "alice", action: "VIEW", details: "Viewed dashboard" },
    { timestamp: "2024-02-27 14:40:00", user: "mike", action: "EXPORT", details: "Exported report" },
    { timestamp: "2024-02-27 14:45:00", user: "admin", action: "LOGIN", details: "Logged in from another IP" },
    { timestamp: "2024-02-27 14:50:00", user: "susan", action: "EDIT", details: "Edited settings" },
    { timestamp: "2024-02-27 15:10:00", user: "john_doe", action: "LOGOUT", details: "User logged out" },
    { timestamp: "2024-02-27 14:20:00", user: "admin", action: "LOGIN", details: "Logged in from IP 192.168.1.1" },
    { timestamp: "2024-02-27 14:30:00", user: "john_doe", action: "UPDATE", details: "Updated record ID 123" },
    { timestamp: "2024-02-27 14:35:00", user: "admin", action: "DELETE", details: "Deleted user ID 45" },
    { timestamp: "2024-02-27 15:00:00", user: "alice", action: "VIEW", details: "Viewed dashboard" },
    { timestamp: "2024-02-27 14:40:00", user: "mike", action: "EXPORT", details: "Exported report" },
    { timestamp: "2024-02-27 14:45:00", user: "admin", action: "LOGIN", details: "Logged in from another IP" },
    { timestamp: "2024-02-27 14:50:00", user: "susan", action: "EDIT", details: "Edited settings" },
    { timestamp: "2024-02-27 15:10:00", user: "john_doe", action: "LOGOUT", details: "User logged out" },
  ];

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const response = await axiosClient.get("/api/MappingDB");
    //     setTableData(response);
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // };
    // fetchData();
    setTableData(logs);
  }, []);
  
  return (
    <div>
      {tableData.length === 0 ? <p >⚠️ Data is empty</p> : <ReusableTable data={tableData} />}
    </div>
  );
};

export default AuditLogsTable;
